

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop, PropSync, Watch} from "vue-property-decorator";
import {IShortServiceProvider} from "@/model/shortInterfaces";
import {IOnOffHandlers} from "bonomo";
import {IErrors} from "@/model/IErrors";
import HelpCard from "@/components/shared/HelpCard.vue";
import {namespace} from "vuex-class";
import ServiceProviderChip from "@/components/shared/chips/ServiceProviderChip.vue";
import {IRestrictCellsActionParam} from "@/model/Locker/lockerInterfaces";
import LMServiceProviderRestrictionLine from "@/components/locker/modules/LMServiceProviderRestrictionLine.vue";

const serviceProviderModule = namespace("serviceProviderModule");
const lockerModule = namespace("lockerModule");

@Component({
  components: {
    HelpCard,
    ServiceProviderChip,
    LMServiceProviderRestrictionLine,
  }
})
export default class LMRestrictCellDialog extends Vue {

  @PropSync('showing')
  protected dialogShowing!: boolean;
  @Prop()
  private lockerId!: number;
  @Prop({})
  private cellId!: number;

  @Prop({default : false})
  private persistent!: boolean;

  @Prop({default: () => []})
  private lockerServiceProviders!: IShortServiceProvider[];

  @Prop({default: () => []})
  private cellRestrictedProviders!: IShortServiceProvider[];

  @serviceProviderModule.Getter('serviceProviders')
  private serviceProvidersAll!: IShortServiceProvider[];

  @lockerModule.Action('addCellRestriction')
  private addCellRestriction!: (param: IRestrictCellsActionParam) => null;

  @lockerModule.Action('deleteCellRestriction')
  private deleteCellRestriction!: (param: IRestrictCellsActionParam) => null;

  private ons: IOnOffHandlers = {};
  private errors: string[] = [];

  private selectedServices: number[] = []
  private disabled: boolean = false;

  private get restrictedServiceProvidersOutsideLocker(): IShortServiceProvider[] {
    return this.cellRestrictedProviders.filter(
        (sp: IShortServiceProvider) => {
          return !this.lockerServiceProviders.includes(sp)
        }
    );
  }

  private created() {
    this.ons = this.$ons({
      'backend.call.OK.lockerUpdated': this.lockerUpdatedOK,
      'backend.call.KO.lockerUpdated': this.lockerUpdatedKO,
    });
    this.errors = [];
    this.initList();
  }

  public beforeDestroy() {
    this.$offs(this.ons);
  }

  @Watch("dialogShowing")
  private initList() {
    this.resetList();
    this.cellRestrictedProviders.forEach((sp: IShortServiceProvider) => {
      this.selectedServices.push(sp.id);
    })
  }

  protected spIsOnLocker(sp: IShortServiceProvider) {
    return this.lockerServiceProviders.includes(sp);
  }

  private updateSwitch(id: number, selected: boolean) {
    this.errors = [];
    this.disabled = true;
    const params = {
      lockerId: this.lockerId,
      cellId: this.cellId,
      spId: id
    };

    if (selected) {
      this.addCellRestriction(params);
    } else {
      this.deleteCellRestriction(params);
    }
  }

  private providerAlreadyRestricted(id: number): boolean {
    return !!this.cellRestrictedProviders.find((sp: IShortServiceProvider) => sp.id === id);
  }

  private onClose() {
    this.errors = [];
    this.$emit('close');
  }

  private get getServiceProviderIds(): number[] {
    // as the endpoint is a toggle, we should generate taking in account existing services
    // @ramon: this logic is complex (my fault) so in the future we should change it to a crud version of it
    return [ ...this.newServicesToRestriction(), ...this.servicesToUnrestrict()];
  }

  private newServicesToRestriction(): number[] {
    // add: in selectedServices but not in cellRestrictedProviders -> the ones that will be added
    // this.selectedServices is int[];
    // this.cellRestrictedProviders CellRestrictedProviderInterface[]
    return this.selectedServices.filter((x: number) => !this.providerAlreadyRestricted(x));
  }

  private servicesToUnrestrict(): number[] {
    // add: in cellRestrictedProviders but not in selectedServices -> the ones that will be removed
    // this.selectedServices is int[];
    // this.cellRestrictedProviders CellRestrictedProviderInterface[]
    let res = this.cellRestrictedProviders.filter((x: IShortServiceProvider) => !this.selectedServices.includes(x.id));
    return res.map((x: IShortServiceProvider) => x.id);
  }

  private lockerUpdatedOK() {
    this.disabled = false;
  }

  private lockerUpdatedKO(errors: IErrors) {
    this.disabled = false;
    this.errors = errors._ || ['?????'];
  }

  private resetList() {
    this.selectedServices = [];
  }


}

